import { GROUP_BY_OPTIONS } from '../constants';

export type GroupByBehaviour = {
    averaging: (originalValue: number, uniqueAthleteCount: number) => number;
    normalisation: (originalValue: number, multiplier: number) => number;
};

const defaultBehaviour: GroupByBehaviour = {
    averaging: (value) => value,
    normalisation: (value) => value,
};

//map each behaviour
export const groupByBehaviourMap: Record<string, GroupByBehaviour> = {
    [GROUP_BY_OPTIONS.activity]: {
        averaging: (value, count) => value / (count || 1),
        normalisation: (value, multiplier) => value * multiplier,
    },
    [GROUP_BY_OPTIONS.period]: {
        averaging: (value, count) => value / (count || 1),
        normalisation: (value, multiplier) => value * multiplier,
    },
    // Extend if needed for other groupBy options, only these behaviours are necessary for now
};

export const getGroupByBehaviour = (groupByOption: string): GroupByBehaviour =>
    groupByBehaviourMap[groupByOption] || defaultBehaviour;
